var e=(e,r)=>{var s=document.createElement("a");s.href=r,s.target="_blank",s.className="messenger messenger--light messenger--vertical messenger--faq";var a=e.querySelector(".messengers"),t=a.lastElementChild;a.insertBefore(s,t)};export{e as addFaqLink};
//# sourceMappingURL=add-faq-link.js.map
